import { render, staticRenderFns } from "./CreateOrEditMarketPrice.vue?vue&type=template&id=13831c5d&scoped=true&"
import script from "./CreateOrEditMarketPrice.vue?vue&type=script&lang=js&"
export * from "./CreateOrEditMarketPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13831c5d",
  null
  
)

export default component.exports